<template lang="pug">
.timeline_item.d-flex.flex-row.flex-md-column.align-items-md-center
  img.d-none.d-md-block(:src="icon")
  .lines.d-flex.flex-column.flex-md-row.align-items-center.justify-content-center.i_mt_6.i_mt_sm_0.flex-grow-1.flex-md-grow-0
    .line.line_left.flex-grow-0.flex-md-grow-1
    .dot.flex-grow-0
    .line.line_right.flex-grow-1.flex-md-grow-1
  .infos.w-100.d-flex.flex-column.align-items-md-center.i_mt_4.i_mt_sm_0.flex-grow-1.flex-md-grow-0
    .title.d-flex.align-items-center
      img.d-md-none(:src="icon")
      h5.i_ml_sm_5 {{ title }}
    p.w-100.i_mt_3.i_plr_3.i_plr_sm_0.i_pb_sm_2.i_mt_sm_4.i_mr_sm_3 {{ content }}
</template>

<script>
export default {
  name: "TimelineItem",
  props: {
    title: String,
    content: String,
    icon: String,
  },
  components: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/timeline_item";
</style>
